module.exports = __webpack_public_path__ + "static/fonts/BMEULJIROTTF.ttf?2e60d3cf";